@if (event) {
  <div class="event-description">
    @if (event.picture) {
      <div class="image">
        <img [src]="getEventImage(event.picture)">
      </div>
    }
    <div class="description" [style.width]="!event.picture ? '100%' : '68%'">
      <div class="header-one">
        <div class="part-1 inline">
          <div class="part-1-1 height-30" [style.color]="'white'">{{_date}}</div>
          <div class="part-1-2 height-30" [style.backgroundColor]="opacityColor"></div>
        </div>
        <div class="part-2 inline">
          <div class="part-2-1 height-30" [style.borderBottomColor]="event.eventType.color"></div>
          <div class="part-2-2 height-30" [style.borderTopColor]="event.eventType.color"></div>
        </div>
        <div class="part-3 inline">
          <div class="part-3-1 height-30" [style.backgroundColor]="opacityColor" #tooltip="matTooltip"
          matTooltip="{{event.eventType.name}}"  [matTooltipPosition]="'above'">{{event?.eventType?.name}}</div>
          <div class="part-3-2 height-30" [style.color]="'white'">{{event?.credits ? event?.credits : ''}} {{event?.credits ? 'Credits' : ''}}</div>
        </div>
      </div>
      @if (event.picture) {
        <div class="image-mobile">
          <img [src]="getEventImage(event.picture)">
        </div>
      }
      <div class="title">{{event.title}}</div>
      @if (event.internalDescription) {
        <div class="internal-description">{{event?.internalDescription}}</div>
      }
      <div class="info-not-main-block">
        @if (date) {
          <div class="info-not-main">
            <div class="inm-label">{{'event-preview.date' | translate}}:</div>
            <div class="inm-text">{{date}}</div>
          </div>
        }
        @if (time) {
          <div class="info-not-main">
            <div class="inm-label">{{'event-preview.time' | translate}}:</div>
            <div class="inm-text">{{time}}</div>
          </div>
        }
        @if (location) {
          <div class="info-not-main">
            <div class="inm-label">{{'event-preview.location' | translate}}:</div>
            <div class="inm-text">{{location}}</div>
          </div>
        }
        @if (event.locationDetail) {
          <div class="info-not-main">
            <div class="inm-label">{{'event-preview.locationDetail' | translate}}:</div>
            <div class="inm-text">{{event.locationDetail}}</div>
          </div>
        }
        @if (event?.organization?.name) {
          <div class="info-not-main">
            <div class="inm-label">{{'event-preview.organization' | translate}}:</div>
            <div class="inm-text">@if (event?.city?.name) {
              {{event?.city?.name}},
            } "{{event?.organization?.name}}"</div>
          </div>
        }
        @if (event?.userName) {
          <div class="info-not-main">
            <div class="inm-label">{{'event-preview.manager' | translate}}:</div>
            <div class="inm-text">{{event?.userName}}</div>
          </div>
        }
        @if (event.cost) {
          <div class="info-not-main">
            <div class="inm-label">{{'event.costs' | translate}}:</div>
            <div class="inm-text">{{event?.country?.currency}} {{event?.cost}}.-</div>
          </div>
        }
        @if (event.costFriend) {
          <div class="info-not-main">
            <div class="inm-label">{{'event.costFriend' | translate}}:</div>
            <div class="inm-text">{{event?.country?.currency}} {{event?.costFriend}}.-</div>
          </div>
        }
        @if (event?.pickUp) {
          <div class="info-not-main">
            <div class="inm-label">{{'event.pickup' | translate}}:</div>
            <div class="inm-text">{{event?.pickUp}}</div>
          </div>
        }
        <!--<div class="info-not-main" *ngIf="event?.gender">-->
        <!--<div class="inm-label">{{'event-preview.gender' | translate}}:</div>-->
        <!--<div class="inm-text">{{event?.gender | translate}}</div>-->
      <!--</div>-->
        @if (event.target.length) {
          <div class="info-not-main">
            <div class="inm-label">{{ 'event-preview.target' | translate }}:</div>
            <div class="inm-text">
              @for (tg of event.target; track tg; let last = $last) {
                <span matTooltip="{{(tg.tooltip ? tg.tooltip : '')}}">
                {{ tg.ageMask }}@if (!last) {
                  <span>;</span>
                }&nbsp;
              </span>
              }
            </div>
          </div>
        }
        @if (skills.length) {
        <div class="info-not-main">
          <div class="inm-label">{{'competency.skills' | translate}}:</div>
          <div class="inm-text"  >
            @for (skill of skills; track $index) {
              <div>
                - {{ skill }};
              </div>
            }
          </div>
        </div>
      }
      @if (levels.length) {
        <div class="info-not-main">
          <div class="inm-label">{{'event-preview.level' | translate}}:</div>
          <div class="inm-text"  >
            <div>
              {{ levels.join(', ') }}
            </div>
          </div>
        </div>
      }
    </div>
    <div class="text" [innerHTML]="event.description">
    </div>
    @if (weblinks) {
      <div class="weblinks">
        @for (link of weblinks; track link) {
          <a href="{{link}}" target="_blank">{{link}}</a>
        }
      </div>
    }
    @if (event?.subEvents && event?.subEvent?.length) {
      <div class="sub-events">
        <div class="sub-events-title">{{'event.sub_events' | translate}}</div>
        @if (event?.minSubEventsCount) {
          <div class="min-sub-events">
            ({{'event.min_sub_events_count' | translate}}: {{event?.minSubEventsCount}})
          </div>
        }
        @for (subEvent of event.subEvent; track subEvent) {
          <div class="sub-event">
            @if (subEvent.picture) {
              <div class="picture">
                <img  [src]="getEventImage(subEvent.picture)">
              </div>
            }
            <div class="sub-event-detail">
              <div class="se-title">{{subEvent?.title}}</div>
              @if (subEvent?.minParticipants) {
                <div class="se-info-block">
                  <div class="se-info-title">{{'event.min_participant' | translate}}:</div>
                  <div class="se-info-date">{{subEvent?.minParticipants}}</div>
                </div>
              }
              @if (subEvent?.maxParticipants) {
                <div class="se-info-block">
                  <div class="se-info-title">{{'event.max_participant' | translate}}:</div>
                  <div class="se-info-date">{{subEvent?.maxParticipants}}</div>
                </div>
              }
              @if (subEvent?.fromTime) {
                <div class="se-info-block">
                  <div class="se-info-title">{{'event.from_time' | translate}}:</div>
                  <div class="se-info-date">{{subEvent?.fromTime}}</div>
                </div>
              }
              @if (subEvent?.toTime) {
                <div class="se-info-block">
                  <div class="se-info-title">{{'event.to_time' | translate}}:</div>
                  <div class="se-info-date">{{subEvent?.toTime}}</div>
                </div>
              }
              @if (subEvent?.duration) {
                <div class="se-info-block">
                  <div class="se-info-title">{{'event.duration_temp' | translate}}:</div>
                  <div class="se-info-date">{{subEvent?.duration}} {{'minutes' | translate}}</div>
                </div>
              }
              <!--          <div class="se-description" [innerHTML]="subEvent?.description"></div>-->
              <div class="se-description">{{subEvent?.description}}</div>
            </div>
          </div>
        }
      </div>
    }
    <div class="participant-info">
      <div class="part-1">
        <img src="../assets/images/users.png">
        <span><span class="count">Teilnehmer:</span> {{participant}}/{{event?.maxParticipants}} </span>
        <span class="list">anzeigen</span>
      </div>
      <div class="part-2" >
        <span>Noch  {{event?.maxParticipants - participant}} Plätze verfügbar </span>
      </div>
    </div>
  </div>
</div>
}
